import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoints, spacing } from '@naf/theme';

export const BannerWrapper = styled.div<{ $restrainWidth?: boolean }>`
  overflow: hidden;
  margin-bottom: ${spacing.space40};

  p {
    margin-bottom: ${spacing.space24};

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  ${({ $restrainWidth }) =>
    $restrainWidth &&
    css`
      @media (min-width: ${breakpoints.m}) {
        width: 100%;
        max-width: 33%;
      }
    `}
`;

export const DiscountStateWrapper = styled.div`
  margin-top: ${spacing.space16};
`;
